<template>
    <BaseDialog v-bind="$attrs" v-model:open="open" title="Connect Work IQ">
        <div class="flex flex-col gap-8 justify-start items-start py-6 md:py-10 px-4 md:px-10 md:min-w-100">
            <div class="w-full">
                <div class="flex flex-row justify-between items-center w-full">
                    <div class="flex flex-row gap-2.5 items-center">
                        <i class="bi bi-microsoft text-[#0078D4]" aria-hidden="true"></i>
                        <h3 class="title-subsection">Connect Work IQ</h3>
                    </div>
                    <BaseButton theme="tertiary" class="p-2!" @click="closeDialog()">
                        <i class="bi bi-x text-3xl text-[#939292]" aria-hidden="true"></i>
                    </BaseButton>
                </div>
            </div>

            <div class="flex flex-col gap-4 w-full">
                <p class="body-small text-valence-grey-750">
                    Connecting Work IQ lets Nadia draw on your Microsoft 365 activity to give you more relevant, in-the-moment coaching. She'll be able to reference things like:
                </p>
                <ul class="flex flex-col gap-2.5 w-full">
                    <li v-for="item in dataItems" :key="item.label" class="flex flex-row gap-2.5 items-start body-small text-[#262626]">
                        <i :class="item.icon" class="text-[#0078D4] mt-0.5" aria-hidden="true"></i>
                        <span>{{ item.label }}</span>
                    </li>
                </ul>
                <p class="body-small text-valence-grey-750">
                    You can disconnect Work IQ at any time from your integration settings. You'll be taken to Microsoft to finish connecting.
                </p>
            </div>

            <div class="flex flex-row gap-2.5 justify-end w-full">
                <BaseButton theme="tertiary" data-test-id="workiq-consent-cancel" @click="closeDialog()">Cancel</BaseButton>
                <BaseButton theme="primary" data-test-id="workiq-consent-continue" @click="confirmConnect()">Continue to Microsoft</BaseButton>
            </div>
        </div>
    </BaseDialog>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseDialog from "~vue/components/BaseDialog.vue";
import { logUserInteraction } from "~vue/utils/logUtils";

defineOptions({ inheritAttrs: false });

const open = defineModel<boolean>("open");

const emit = defineEmits<{
    confirm: [];
}>();

// Copy is a product/legal call (PLT-1758 open question) — this describes the Microsoft 365 data
// WorkIQ can surface, kept deliberately high level pending review.
const dataItems: { icon: string; label: string }[] = [
    { icon: "bi bi-envelope", label: "Recent emails and who you've been corresponding with" },
    { icon: "bi bi-calendar2-week", label: "Your calendar and upcoming meetings" },
    { icon: "bi bi-chat-dots", label: "Teams chats and collaboration activity" },
    { icon: "bi bi-files", label: "Documents and files you've been working on" },
];

const closeDialog = () => {
    open.value = false;
};

const confirmConnect = () => {
    logUserInteraction("workiq_integration_consent_accepted");
    open.value = false;
    emit("confirm");
};
</script>

<style scoped></style>
